var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLateralXRay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "0.942492in",
    height: "0.898587in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 109 104",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {stroke:#CCCCCC;stroke-width:0.347764}\n    .a2 {fill:#FEFEFE}\n    .a1 {fill:#E8E9EA}\n    .a3 {fill:#E9E9E9}\n    .a0 {fill:#F3F8FC}\n   "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2975208693936"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a0 st0",
    d: "M104 70c0,-1 -2,-1 -3,-1 -1,1 -2,1 -3,1 -1,0 -1,0 -2,0l-8 0c-1,0 -1,0 -1,0 -1,0 -2,0 -3,0l-3 0c0,0 0,0 0,0l-6 0c-1,0 -2,-1 -3,-1l-12 0c-1,0 -1,-1 -2,-1 -1,0 -1,0 -1,0l-11 -1c0,0 0,0 -1,-1l-2 0c-1,0 -1,0 -1,0l-3 -1c0,0 0,0 0,0 -2,-1 -4,-2 -6,-3l-1 0c0,-1 -1,-1 -1,-2 -1,-1 -3,-3 -3,-4 0,-1 -1,-2 -1,-3 0,0 0,-1 0,-1 0,-1 -1,-4 -1,-5 1,-1 0,-2 1,-3 0,-1 0,-2 0,-3 0,-1 0,-1 0,-2 0,-1 0,-1 0,-2 0,-1 0,-1 0,-2 1,0 1,-1 1,-1l0 -5 5 2c0,0 0,0 1,0 0,0 0,0 1,0 1,0 4,1 5,1 0,0 1,0 1,0 1,0 1,1 1,1 1,0 2,0 3,0 1,0 2,0 3,1 7,1 19,2 27,2l2 0c0,0 0,0 1,0l1 0c1,0 1,1 2,1 2,0 4,0 7,0 1,0 2,0 3,0 1,0 1,0 1,0 1,0 2,0 2,0 1,0 1,0 2,0l6 -1c1,0 1,0 2,0 1,0 2,0 3,0 1,0 2,0 2,-1 0,0 0,-1 0,-1l-5 -22c-1,-2 0,-4 1,-6 1,0 1,0 1,0 1,-1 0,-1 0,-2l-2 -2c0,0 -1,-1 -1,-2l-76 0 -1 2c0,0 0,0 0,0l-2 4c0,0 0,0 0,0 -2,-1 -4,4 -6,5 0,1 0,1 0,1 -1,1 -1,1 -2,2l-1 2c0,1 0,2 -1,3l-3 7c0,1 0,1 0,1l0 1c-1,1 -1,1 -1,1l-1 2c-4,25 1,-2 -5,28 2,4 -11,12 3,25 0,0 0,1 0,1 0,0 0,0 1,0 0,0 0,0 0,1 1,0 1,0 2,1l0 0c1,1 3,2 4,2 0,0 1,0 1,0 1,1 2,1 2,1 1,0 1,0 1,0 1,0 1,1 1,1l5 3c0,0 0,0 1,0l5 1c1,0 1,0 2,0l6 4c0,1 1,1 1,1 1,0 2,0 3,0 0,0 1,0 2,0 2,1 5,1 7,1 1,0 2,0 3,0 0,0 1,0 1,0 0,0 1,0 1,0 1,0 1,1 1,1l4 0c1,0 2,0 3,0 1,0 3,0 5,0 1,0 2,1 3,1 1,0 1,0 2,0 1,0 3,0 5,0 1,0 1,0 2,0 1,0 2,0 3,0l8 1c1,0 3,0 5,0 1,0 3,0 4,0 1,-1 3,-2 4,-3 0,0 0,0 0,-1l2 -2c1,-2 1,-3 0,-5 0,0 0,-1 0,-1 -1,-1 -1,-1 -1,-2 0,-1 -1,-1 -1,-1 0,-1 0,-1 0,-2l-1 -1c0,0 0,0 0,-1l1 5c-1,0 -1,0 -1,-1 0,-2 -1,-5 -1,-7 0,-2 0,-4 0,-5 0,-2 1,-4 1,-6 0,0 0,-1 0,-1 0,0 0,0 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M98 63c0,2 2,17 2,18 3,-1 4,-16 3,-19 -2,1 -3,1 -5,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M103 53c2,3 0,6 0,9 -3,2 -2,1 -5,1 1,-2 -1,-5 -1,-8 0,-4 3,-2 6,-2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M97 17c4,4 5,13 5,19 -4,0 0,-3 -7,1 0,-3 0,-8 0,-10 1,-4 -2,-9 2,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M95 37c-2,7 -5,12 5,12 7,0 2,-9 2,-13 -3,0 -2,-3 -7,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M92 18c5,5 6,13 6,20 -7,-2 -1,-1 -6,0 0,-3 0,-7 0,-10 0,-3 -2,-9 0,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M92 38c0,5 -4,11 4,11 6,0 3,-8 2,-11 -2,0 -2,-2 -6,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M95 63c0,2 2,20 2,21 3,-4 3,-16 3,-21 -2,0 -3,0 -5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M100 53c1,3 0,7 0,10 -3,2 -2,1 -5,0 0,-3 -1,-5 -1,-8 0,-3 3,-2 6,-2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M86 12c2,3 4,7 5,12 1,4 1,9 1,12 -7,-2 0,0 -7,0 -1,-3 0,-8 0,-12 1,-3 -1,-10 1,-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M85 36c-2,6 -3,11 4,13 7,-1 4,-9 3,-13 -4,-2 -5,0 -7,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M59 23c6,-4 7,14 7,17 -4,-1 -8,-1 -12,0 0,-5 -1,-32 6,-4 0,-9 1,-1 -1,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M54 40c-2,5 -2,11 5,8 2,-1 11,5 7,-8 -2,-1 -6,-2 -12,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M89 62c0,1 0,6 0,11 1,4 1,8 1,8 2,-1 3,-4 4,-8 1,-4 1,-8 1,-11 -2,0 -4,0 -6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M93 52c5,4 2,6 2,10 -5,3 -3,1 -6,0 0,-3 -3,-10 4,-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M79 19c4,4 4,14 4,20 -5,-3 -3,-2 -7,0 0,-5 -2,-20 3,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M76 39c-1,5 -4,6 4,10 7,-4 4,-5 3,-10 -6,-4 -5,0 -7,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M46 22c-4,4 -4,12 -4,18 7,-1 5,-1 11,0 0,-8 -8,-39 -5,-6l-1 1 -1 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M53 40c1,4 2,12 -5,8 -3,-3 -8,4 -6,-9 7,0 8,1 11,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M70 18c3,4 4,15 4,20 0,0 -5,0 -6,0 0,-3 0,-18 2,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M68 38c0,5 -4,9 4,11 7,0 2,-8 2,-11 -2,0 -4,0 -6,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M82 62c0,4 -1,18 1,21 4,-3 6,-16 6,-21 -3,0 -5,0 -7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M86 52c6,6 3,3 3,10 -7,2 -4,0 -7,0 0,-1 -4,-9 4,-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a3 st0",
    d: "M37 26c5,-1 5,12 5,15 -2,0 -2,-2 -5,-2 -3,0 -2,1 -5,1 0,-2 0,-4 0,-7 0,-6 -3,-12 5,-6 0,2 -1,4 0,6l0 2 0 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M32 41c1,0 3,-2 5,-2 3,0 4,2 5,2 1,5 2,11 -5,6 -2,0 -3,3 -5,-1 -2,-2 0,-4 0,-5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M81 62c-2,0 -5,-1 -7,0 0,1 2,20 3,21 4,-4 4,-14 4,-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M78 52c7,4 4,4 3,10 -2,0 -5,-1 -7,0 -3,-4 -1,-9 4,-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M60 62c0,7 0,12 -2,17 -1,10 9,-8 9,-8 5,-2 -5,18 4,7 3,-7 2,-9 2,-16 -4,0 -9,0 -13,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M73 52c3,4 2,6 0,10 -5,0 -9,1 -13,0 -1,-2 -3,-8 1,-8 3,0 3,-2 6,-1 4,1 2,-1 6,-1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M59 61c0,5 -3,10 -4,15 -8,10 -1,-5 -2,-6 -1,-1 -10,17 -8,6 3,-7 1,-9 1,-16 4,0 9,0 13,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M58 52c3,3 2,5 1,9 -6,1 -8,0 -13,-1 -1,-3 -1,-6 3,-7 2,0 3,1 4,1 2,0 2,-2 5,-2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a1 st0",
    d: "M38 69c0,3 -5,9 0,7 6,-6 7,-8 7,-17 -2,0 -3,0 -5,1 -4,1 -3,0 -7,0 0,12 -3,9 -4,15 4,2 7,-5 9,-6 0,-2 0,-1 1,-2 0,1 0,1 -1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 st0",
    d: "M33 54c0,-1 1,0 3,-1 3,-1 7,-1 10,-1 1,2 2,4 -1,7 -5,-1 -6,3 -12,1 0,-2 -2,-4 0,-6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateralXRay);
export default __webpack_public_path__ + "static/media/LateralXRay.b21e1b37bd3f6442f5652d56f0f0922a.svg";
export { ForwardRef as ReactComponent };